module.exports = __webpack_public_path__ + "images/send.svg?dc96d38178892a86db62254fd0c2f039";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/send.svg
// module id = 356
// module chunks = 0